import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';




function renderInput(inputProps) {
  const { classes, autoFocus, label, value, ref, onSelect, ...other } = inputProps;

  
  function _onKeyPress (key,props)
  {
    if( key == 'Enter' && onSelect != null)
      setTimeout( onSelect, 0, value );
  }
  

  return (
    <TextField
      autoFocus={autoFocus}
      className={classes.textField}
      value={value}
      inputRef={ref}
      label={label}
      onKeyPress={event =>
      {
        _onKeyPress(event.key, inputProps);

      }}
      InputProps={{
        classes: {
          input: classes.input,
        },
        ...other,
      }}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </strong>
          );
        })}
      </div>
    </MenuItem>
  );
}

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}



const styles = theme => ({
  input:
  {

  },
  container: {
    flexGrow: 1,
    position: 'relative',
    margin:10,
    marginTop:15
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0,
    zIndex:100000
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

class ComboBox extends React.Component {
  constructor(props)
  {
    super(props);
    this.state.value = props.value;
    
  }

    state = {
        value: '',
        suggestions: [],
    };

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value,this),
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.props.value) {
      this.setState({value: nextProps.value});
    }
  }

  handleChange = (event, { newValue }) => {
    
    this.setState({
      value: newValue,
    });
    if( this.onChange != null )
      this.onChange(newValue);

    
    //this.state.value = newValue;
  };

  updateList = (list) =>
{
    this.setState(
        {
            suggestions : list
        }
    )
}



handleSuggestionSelected = (event,data) =>
{
  if( this.onSelect != null && data.method == 'click')
    this.onSelect(data.suggestionValue);
}

  render() {
    const { classes } = this.props;

    this.getSuggestions = this.props.getSuggestions;
    this.onChange = this.props.onChange;
    this.onSelect = this.props.onSelect;

    return (
      <Autosuggest 
        theme={{
          input: classes.input,
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={this.handleSuggestionSelected}
        inputProps={{
          autoFocus: true,
          classes,
          placeholder: '',
          label: this.props.label,
          value: this.state.value,
          onChange: this.handleChange,
          onSelect: this.props.onSelect
        }}
      />
    );
  }
}

ComboBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComboBox);



// WEBPACK FOOTER //
// ./src/combo-box.js